const styles = {
  button: {
    marginRight: 16,
    width: 120,
    marginBottom: 16,
  },
};

export default styles;
